<template>
  <section id="about">
    <v-parallax src="/static/backgrounds/bg2.jpg" height="auto">
      <v-layout
        column
        class="white--text mt-5"
      >
        <h2 :class="displayTitle + ' mt-5 text-xs-center pt-3 pb-0'">Nuestros Trabajos</h2>
        <v-container fluid>
          <v-layout row wrap class="py-5">
            <v-flex xs12 md-6 lg-3 v-for="(work, i) in works" :key="i" :class="cardsClass"
              @mouseenter="scaleIn"
              @mouseleave="scaleOut"
              >
              <v-card color="transparent">
                <v-card-media :src="`/static/pages/${work.img}.jpg`" height="350px">
                  <v-spacer></v-spacer>
                  <v-btn :href="work.link" target="_blank" color="deep-purple darken-1" class="media-card-btn" large dark>Visitar</v-btn>
                  <v-spacer></v-spacer>
                </v-card-media>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-parallax>
  </section>
</template>

<script>
export default {
  data () {
    return {
      cardsClass: "px-3 mb-5",
      displayTitle: 'display-4',
      works: [
        {
          img: 'nancy',
          link: 'http://fotografianp.com'
        },
        {
          img: 'climalyn',
          title: 'Climalyn',
          link: 'http://climalyn.com.ar'
        },
        {
          img: 'pines',
          link: 'http://pinespublicitarios.com.ar'
        },
        {
          img: 'pruebate',
          link: 'http://www.pruebate.hol.es'
        }
      ]
    }
  },
  methods: {
    scaleIn (event) {
      event.target.classList.remove('scaleOut');
      event.target.classList.add('scaleIn');
    },
    scaleOut () {
      event.target.classList.remove('scaleIn');
      event.target.classList.add('scaleOut');
    }
  },
  mounted() {
    if(window.innerWidth < 800) {
      this.cardsClass = 'mb-4';
      this.displayTitle = 'display-2'
    }
  }
}
</script>

<style scoped>

.media-card-btn {
  position: relative;
  bottom: -80%;
}

.scaleIn {
  animation: scaleIn 0.3s forwards;
}

.scaleOut {
  animation: scaleOut 0.3s forwards;
}

@keyframes scaleIn {
  from {transform: scale(1)}
  to {transform: scale(1.1)}
}

@keyframes scaleOut {
  from {transform: scale(1.1)}
  to {transform: scale(1)}
}

</style>





// WEBPACK FOOTER //
// src/components/sections/About.vue